import React, { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setPhotoContextDims,
  selectPhotoContextDims,
} from "slices/createPictureSlice";
import Spinner from "components/General-UI/Spinner";
import useAttachCameraTrack from "components/Hooks/useAttachCameraTrack";
import { clearCurrentCameraTrack } from "slices/devicesSlice";
import { MAX_AVATAR_SIDE_LENGTH } from "constants/constants";

const RenderUseCameraFeed = () => {
  const dispatch = useDispatch();
  const photoContextDims = useSelector(selectPhotoContextDims);
  const videoElement = useRef<HTMLVideoElement | null>(null);

  useAttachCameraTrack(videoElement);

  const setPhotoContexts = useCallback(
    (node: HTMLVideoElement | null) => {
      if (node) {
        videoElement.current = node;
        node.addEventListener("loadedmetadata", () => {
          dispatch(
            setPhotoContextDims({
              width: videoElement?.current!.videoWidth,
              height: videoElement?.current!.videoHeight,
            })
          );
        });
      }
    },
    [dispatch]
  );

  useEffect(() => {
    return () => clearCurrentCameraTrack();
  }, []);

  return (
    <>
      {!photoContextDims ? (
        <Spinner message="" bgDark={true} spinnerLight={true} />
      ) : null}
      <video
        id="createPictureVideoElement"
        ref={setPhotoContexts}
        className=""
        autoPlay
        muted
      ></video>
      <canvas
        id="createPictureCanvasElement"
        width={MAX_AVATAR_SIDE_LENGTH}
        height={MAX_AVATAR_SIDE_LENGTH}
        hidden
      ></canvas>
    </>
  );
};

export default RenderUseCameraFeed;
